import { request } from "../../../apis";
import { getCurrency } from "../../../plugins/utils";
const CURRENCY = getCurrency();

export const getWithdrawList = ({ params, page }) =>
  request(
    "get",
    `/${CURRENCY}/agent/withdraw/`,
    { ...params, page },
    true,
    false
  );

export const getReceivedList = ({ params, page }) =>
  request(
    "get",
    `/${CURRENCY}/agent/receive/`,
    { ...params, page },
    true,
    false
  );

export const cancelWithdraw = (id) =>
  request("put", `/${CURRENCY}/agent/withdraw/cancel/${id}`, {}, true);

export const receiveReward = (id) =>
  request("put", `/${CURRENCY}/agent/receive/${id}`, {}, true);
